import { render, staticRenderFns } from "./PsEventDialog.vue?vue&type=template&id=51ecc5fd&scoped=true&"
import script from "./PsEventDialog.vue?vue&type=script&lang=js&"
export * from "./PsEventDialog.vue?vue&type=script&lang=js&"
import style0 from "./PsEventDialog.vue?vue&type=style&index=0&id=51ecc5fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ecc5fd",
  null
  
)

export default component.exports